<div edsGrid [ngClass]="{ 'has-edit-button': isEditMode }">
  <ng-container
    *ngIf="isEditMode"
    [brManageContentButton]="document"
    documentTemplateQuery="new-SectionNav-document"
    folderTemplateQuery="new-SectionNav-folder"
    parameter="document"
    [relative]="false"
    root=""
  >
  </ng-container>
</div>

<div *ngIf="sectionNavDocument">
  <!-- Switch on marginBottom -->
  <ng-container *ngIf="marginBottom; else stickyTabs">
    <div [edsSpacing]="marginBottom === 'auto' ? 'xl' : marginBottom">
      <ng-container *ngTemplateOutlet="stickyTabs"></ng-container>
    </div>
  </ng-container>

  <ng-template #stickyTabs>
    <!--  Sticky Tabs -->
    <eds-tabs-sticky
      [links]="sectionNavs"
      [activeTab]="activeTabId"
      (onTabChanged)="onTabChange($event)"
      (onHeightChanged)="onHeightChange($event)"
    ></eds-tabs-sticky>
  </ng-template>
</div>
<!-- If No Document -->
<div
  *ngIf="!document && isEditMode"
  [edsSpacing]="marginBottom === 'auto' ? 'xl' : marginBottom"
  class="no-document"
>
  <div edsGrid class="no-document__component">
    <div class="no-document__overlay">
      Click to configure <strong>{{ componentLabel }}</strong>
    </div>
  </div>
</div>
